"use client";

import { useEffect } from "react";
import { useAuth, useTheme } from "@/lib/store";
import { syncBrowserTimezone } from "@/lib/settings-api";

function shouldDisableServiceWorker() {
  if (typeof window === "undefined") return true;
  return (
    process.env.NODE_ENV !== "production" ||
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  );
}

export function StoreInitializer() {
  const initAuth = useAuth((s) => s.initialize);
  const initTheme = useTheme((s) => s.initialize);

  useEffect(() => {
    initTheme();
    initAuth();
  }, [initAuth, initTheme]);

  // Persist the browser's timezone as the user's SSOT so the AI plan places
  // blocks in the local working window (ISSUE-012). Gated on an existing
  // token so it doesn't fire on the sign-in page; idempotent per device.
  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!localStorage.getItem("de_access_token")) return;
    void syncBrowserTimezone();
  }, []);

  useEffect(() => {
    if (
      typeof window === "undefined" ||
      !("serviceWorker" in navigator) ||
      !shouldDisableServiceWorker()
    ) {
      return;
    }

    void navigator.serviceWorker
      .getRegistrations()
      .then(async (registrations) => {
        await Promise.all(registrations.map((registration) => registration.unregister()));
        if ("caches" in window) {
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
        }
      })
      .catch(() => {
        // Best effort cleanup for localhost/dev only.
      });
  }, []);

  return null;
}
